import React, { useEffect } from "react"

import Link from "./link"

const FixedHeader = ({ isAlt, comingSoon = "Coming Soon", isEpisode, duration, title, caption, link, scroll, button = "Book Now" }) => {
  useEffect(() => {
    const timeout = setTimeout(function () {
      document.querySelector(".fixed--header")?.classList?.add("active")
    }, 1000)
    const interval = setInterval(function () {
      if (document.querySelector(".bg-beige")) {
        const top = document.querySelector(".bg-beige")?.offsetTop
        const bottom = document.querySelector(".bg-beige")?.offsetTop + document.querySelector(".bg-beige")?.offsetHeight
        if (window.pageYOffset > top && window.pageYOffset < bottom) {
          document.querySelector(".scrolling--header")?.classList?.add("bg-beige-inner")
        } else {
          document.querySelector(".scrolling--header")?.classList?.remove("bg-beige-inner")
        }
      }
      if (window.pageYOffset < window.innerHeight) {
        document.querySelector(".scrolling--header")?.classList?.remove("active")
        if (document.querySelector(".scrolling--header")) {
          document.querySelector(".mobile--header")?.classList?.add("light")
        }
      } else {
        document.querySelector(".scrolling--header")?.classList?.add("active")
        document.querySelector(".mobile--header")?.classList?.remove("light")
      }
    }, 200)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [])

  const scrollDown = () => {
    const height = document.getElementById("contact")?.offsetTop
    window.scrollTo({ top: height, left: 0, behavior: "smooth" })
  }

  const As = isAlt ? "a" : Link

  return (
    <>
      {!isEpisode ? (
        <>
          <div className='fixed--header desktop'>
            <div className='ml60 p40 flex align-center m-justify m-m0'>
              {comingSoon !== false && (
                <p className='m0 small m-100 m-center now-wrap'>
                  {title}{" "}
                  <span className='ml5 pl20 with-dot'>
                    <span className=''>{comingSoon}</span>
                  </span>
                </p>
              )}
              <div className='cta m-hide mla'>
                <span className='small mr20'>{caption}</span>{" "}
                {scroll ? (
                  <p onClick={scrollDown} role='presentation' className='button inverse wide h-white link white'>
                    Register Interest
                  </p>
                ) : (
                  <As target='_blank' rel='noreferrer' className={`button ${isAlt ? "white-btn" : "h-white white"} inverse wide link`} to={link} href={link}>
                    {button}
                  </As>
                )}
              </div>
            </div>
          </div>
          <div className='scrolling--header'>
            <div className='p40 pt10 pb10 flex align-center bg-light'>
              {comingSoon !== false && (
                <p className='m0 small m-100 m-center now-wrap'>
                  {title}{" "}
                  <span className='with-dot'>
                    <span className='op-50'>{comingSoon}</span>
                  </span>
                </p>
              )}
              <div className='cta  mla'>
                <span className='small mr20'>{caption}</span>{" "}
                {scroll ? (
                  <p onClick={scrollDown} role='presentation' className='button inverse wide link'>
                    Register Interest
                  </p>
                ) : (
                  <As target='_blank' rel='noreferrer' className={`button ${isAlt ? "brown" : ""} inverse wide link`} to={link} href={link}>
                    {button}
                  </As>
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='fixed--header desktop'>
            <div className='ml60 p40 flex align-center m-justify m-m0'>
              <p className='m0 small m-100 m-center now-wrap'>
                Kirra Point Series{" "}
                <span className='ml5 pl20 with-dot'>
                  <span className='op-50 m-op-100'>{title}</span>
                </span>
              </p>
              {duration && (
                <div className='mla small flex align-center'>
                  <span className=' mr20 clock-icon' /> <span className=''>{`${duration} video`}</span>
                </div>
              )}
            </div>
          </div>
          <div className='scrolling--header'>
            <div className='p40 pt10 pb10 flex align-center bg-light'>
              <p className='m0 small m-100 m-center now-wrap  py-20'>
                Kirra Point Series{" "}
                <span className='with-dot'>
                  <span className='op-50'>{title}</span>
                </span>
              </p>
              {duration && (
                <div className='mla small flex align-center'>
                  <span className=' mr20 clock-icon-dark' /> <span className=''>{`${duration} video`}</span>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default FixedHeader
